/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'policies';
const componentName = 'policy-rule-summary';
const prefix = `${moduleName}.${componentName}`;

export const matchHeaderLabel = `${prefix}.matchHeaderLabel`;
export const actionHeaderLabel = `${prefix}.actionHeaderLabel`;

export const ENGLISH = {
    [matchHeaderLabel]: 'Match ({0})',
    [actionHeaderLabel]: 'Action ({0})',
};
